<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h2 class="purple bold">Registro de professor</h2>
      </b-col>
    </b-row>

    <b-row class="teacher-profile mt-50">
      <b-col md="3">
        <ProfilePhoto
          :isEditing="!!id"
          :photo="photo"
          :callback="setNewPhoto"
        />
      </b-col>

      <b-col>
        <b-row>
          <b-col md="1" class="status">
            <b-form-group label="Ativo">
              <b-form-checkbox
                switch
                v-model="teacher.is_active"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group class="required" description>
              <label for="label">Nome</label>
              <b-form-input
                v-model="teacher.User.name"
                type="text"
                placeholder
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group class="required" description>
              <label for="label">E-mail</label>
              <b-form-input
                v-model="teacher.User.email"
                type="text"
                placeholder
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group description>
              <label for="label">Telefone</label>
              <b-form-input
                v-model="teacher.User.phone"
                type="text"
                v-mask="['(##) #####-####']"
                placeholder="(__) _____-____"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group class="required" description>
              <label for="label">CPF</label>
              <b-form-input
                v-model="teacher.User.cpf"
                :state="verificarCpf"
                type="text"
                v-mask="['###.###.###-##']"
                placeholder="___.___.___-__"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group description>
              <label for="label">RG</label>
              <b-form-input
                v-model="teacher.User.rg"
                type="text"
                v-mask="['###########']"
                placeholder="Somente números"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group description>
              <label for="label">País</label>
              <multiselect
                v-model="country"
                :options="countriesList"
                :close-on-select="true"
                :clear-on-select="false"
                label="name"
                track-by="name"
                placeholder="Selecione um país"
                selectLabel
                selectedLabel
                deselectLabel
              />
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group description>
              <label for="label">Estado</label>
              <multiselect
                v-model="state"
                :options="statesList"
                :close-on-select="true"
                :clear-on-select="false"
                label="name"
                track-by="name"
                placeholder="Selecione um estado"
                selectLabel
                selectedLabel
                deselectLabel
              />
            </b-form-group>
          </b-col>

          <b-col style="z-index: 10">
            <b-form-group class="required" description>
              <label for="label">Ciclos</label>
              <select-multiple
                :callback="selectCycle"
                :options="cyclesForSelect"
                :hasSelectAll="false"
                :initial="cyclesSelected"
                label="Ciclos"
                placeholder="Selecione um Ciclo"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class>
          <b-col>
            <b-form-group
              class="accordion-materias"
              label="Áreas do Conhecimento"
              style="z-index: 1"
            >
              <div class="accordion" role="tablist">
                <template v-if="cyclesFilledsWithSubjects.length">
                  <b-card
                    no-body
                    v-for="cycle in cyclesFilledsWithSubjects"
                    :key="cycle.id"
                  >
                    <b-card-header header-tag="header" role="tab">
                      <p block v-b-toggle="'accordion-' + cycle.id">
                        {{ cycle.name }}
                      </p>
                    </b-card-header>

                    <b-collapse
                      :id="'accordion-' + cycle.id"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <b-form-checkbox-group
                          :id="'checkbox-group-' + cycle.id"
                          v-model="subjectsSelected"
                          name="flavour-2"
                        >
                          <b-form-checkbox
                            v-for="subject in cycle.Subjects"
                            :key="subject.id"
                            :value="subject.id"
                            >{{ subject.designation }}</b-form-checkbox
                          >
                        </b-form-checkbox-group>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </template>
                <p v-else class="text-muted text-center mt-3">
                  Selecione um ciclo com áreas do conhecimento para que elas
                  apareçam aqui.
                </p>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-3 login-fields" v-if="!id">
          <b-col md-3>
            <b-form-group class="required" description>
              <label for="label">Senha</label>
              <b-form-input
                v-model="teacher.User.password"
                :class="{ isInvalid: !teacher.User.password.length >= 6 }"
                type="password"
                placeholder
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col md-3>
            <b-form-group class="required" description>
              <label for="label">Confirme a senha</label>
              <b-form-input
                v-model="teacher.User.confirmPassword"
                :class="{ isInvalid: !confirmPasswordValidation }"
                type="password"
                placeholder
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row align-v="center" class="mt-5">
      <b-col></b-col>

      <b-col></b-col>

      <b-col class="text-right">
        <b-button class="btn large outline" v-b-modal.tutoria
          >Atribuir Tutorados</b-button
        >
      </b-col>
    </b-row>

    <b-row align-v="center" class="mt-5">
      <b-col></b-col>

      <b-col class="text-right">
        <b-button
          class="large blue outline"
          :to="{
            name: 'professores',
            params: {
              cycle: this.$route.params.cycle,
              subject: this.$route.params.subject,
              page: this.$route.params.page,
            },
          }"
          >Voltar</b-button
        >
      </b-col>

      <b-col></b-col>

      <b-col class="text-right">
        <b-button @click="submit" class="large blue">Salvar</b-button>
      </b-col>
    </b-row>

    <TutoriaModal :teacherId="this.id" :teacherCycles="cyclesSelected" />
  </b-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import utils from "@/utils";

import ProfilePhoto from "@/components/ProfilePhoto";
import TutoriaModal from "@/components/modals/TutoriaModal";
import SelectMultiple from "@/components/inputs/SelectMultiple.vue";
import httpRda from "../../../http-rda";
import { isPhotoFile } from "@/utils/photo";

export default {
  name: "perfil-professor",
  components: {
    ProfilePhoto,
    TutoriaModal,
    SelectMultiple,
  },

  data() {
    return {
      photo: null,
      cyclesForSelect: [],
      cyclesSelected: [],
      childhoodCycles: [],
      subjectsSelected: [],
      cyclesFilleds: [],
      subjectsByCycles: {},
      loadingCycles: false,

      country: null,
      state: null,

      teacher: {
        is_active: true,
        User: {
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
          birth_date: null,
          cpf: "",
          rg: "",
          phone: "",
          gender: "",
          state_origin: "",
          country_origin: "",
        },
      },

      breadcrumb: [
        {
          text: "Comunidade",
          href: "/comunidade",
        },
        {
          text: "Professores",
          href: "/professores",
        },
        {
          text: "Registro de professor",
          href: "/perfil",
          active: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      countriesList: "shared/countries",
      statesList: "shared/states",
      teacherToUpdate: "community/teacher",
    }),

    confirmPasswordValidation() {
      return this.teacher.User.password === this.teacher.User.confirmPassword;
    },

    teacherToSave() {
      const Subjects = this.subjectsSelected;
      const data = {
        Subjects,
        is_active: this.teacher.is_active,
        User: {
          name: this.teacher.User.name,
          email: this.teacher.User.email,
          cpf: this.teacher.User.cpf,
          rg: this.teacher.User.rg,
          Phones: this.teacher.User.phone ? [this.teacher.User.phone] : [],
          gender: "undefined",
          state_origin: this.state ? this.state.name : "",
          country_origin: this.country ? this.country.name : "",
        },
      };
      return data;
    },

    teacherToSaveCreate() {
      const Subjects = this.subjectsSelected;
      const data = {
        Subjects,
        is_active: this.teacher.is_active,
        User: {
          name: this.teacher.User.name,
          email: this.teacher.User.email,
          password: this.teacher.User.password,
          cpf: this.teacher.User.cpf,
          rg: this.teacher.User.rg,
          Phones: this.teacher.User.phone ? [this.teacher.User.phone] : [],
          gender: "undefined",
          state_origin: this.state ? this.state.name : "",
          country_origin: this.country ? this.country.name : "",
        },
      };
      return data;
    },

    id() {
      return this.$route.params.id;
    },

    verificarCpf() {
      if (this.teacher.User.cpf != undefined) {
        const validarCPF = utils.validateCPF(this.teacher.User.cpf);
        return validarCPF ? true : false;
      } else {
        return false;
      }
    },

    cyclesFilledsWithSubjects() {
      return this.cyclesFilleds.filter(
        (cycle) => cycle.id && cycle.Subjects && cycle.Subjects.length > 0
      );
    },
  },

  methods: {
    ...mapActions({
      getCountries: "shared/getCountries",
      getStates: "shared/getStates",
      createTeacher: "community/createTeacher",
      updateTeacher: "community/updateTeacher",
      updateTeachersSubjects: "community/updateTeachersSubjects",
      savePhoto: "community/saveTeacherPhoto",
      savePhone: "community/saveTeacherPhone",
      updateTeacherPhone: "community/updateTeacherPhone",
      getLoginStatus: "community/getLoginStatus",
    }),

    ...mapMutations({
      resetState: "shared/RESET_STATE",
      resetStateCommunity: "community/RESET_STATE_COMMUNITY",
    }),

    resetStates() {
      this.resetState();
      this.resetStateCommunity();
    },

    async getCyclesForSelect() {
      try {
        const res = await httpRda.get("/cycles-for-select");
        this.cyclesForSelect = res.data.cycles || [];
      } catch (error) {
        this.$swal.fire({
          title: "Erro",
          text: "Não foi possível carregar os ciclos. Tente novamente mais tarde.",
          icon: "error",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    async create() {
      try {
        const data = this.teacherToSaveCreate;

        const response = await this.createTeacher(data);
        const id = response.data.teacher.id;

        await this.updatePhoto(id);

        await httpRda.post(`/teachers/${id}/childhood-cycle`, {
          cycles: this.childhoodCycles,
        });

        this.successReq();
      } catch (error) {
        this.errorReq(error);
      }
    },

    async update() {
      try {
        const data = this.teacherToSave;

        await this.updateTeacher({
          ...data,
          ...data.User,
          id: this.id,
        });
        const id = this.id;

        await this.updatePhoto(id);

        const subjects = this.subjectsSelected;

        if (subjects.length) {
          await this.updateTeachersSubjects({ teacher_id: id, subjects });
        }

        await httpRda.post(`/teachers/${id}/childhood-cycle`, {
          cycles: this.childhoodCycles,
        });

        this.$swal.fire({
          title: "Sucesso",
          text: "Atualizado com sucesso",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });

        let self = this;
        setTimeout(() => {
          self.redirectTo();
        }, 200);
      } catch (error) {
        this.errorReq(error);
      }
    },

    async setTeacher() {
      this.teacher = await httpRda
        .get(`/teachers/${this.id}/edit`)
        .then((res) => res.data.teacher);
      this.country = this.countriesList.find(
        (c) => c.name === this.teacher.User.country_origin
      );
      this.state = this.statesList.find(
        (s) => s.name === this.teacher.User.state_origin
      );

      if (this.teacher.cycles) this.cyclesSelected = this.teacher.cycles;

      if (this.teacher.subjects) {
        this.subjectsSelected = this.teacher.subjects.map((s) => s.id);
      }

      if (this.teacher.User.photo) this.photo = this.teacher.User.photo;

      if (
        this.teacher &&
        this.teacher.User &&
        Array.isArray(this.teacher.User.Phones) &&
        this.teacher.User.Phones.length
      )
        this.teacher.User.phone = this.teacher.User.Phones[0].number;

      if (this.cyclesSelected && this.cyclesSelected.length) {
        await this.selectCycle(this.cyclesSelected);
      }
    },

    async updatePhoto(id) {
      if (!isPhotoFile(this.photo)) {
        return;
      }

      const bodyFormData = new FormData();

      bodyFormData.append("file", this.photo);

      await this.savePhoto({ id, file: bodyFormData });
    },

    async getSubjectsByCycles(cycleIds) {
      const res = await httpRda.get("/subjects-by-cycles", {
        params: {
          cycleIds,
        },
      });

      return res.data.cycles;
    },

    async selectCycle(params) {
      if (this.loadingCycles) {
        return;
      }

      this.cyclesSelected = params;

      this.childhoodCycles = this.cyclesSelected
        .filter((cy) => cy.id === 6 || cy.id === 8)
        .map((cy) => cy.id);

      const newCycles = this.cyclesSelected.filter(
        (cycle) => !this.subjectsByCycles[cycle.id]
      );

      if (newCycles.length) {
        this.loadingCycles = true;
        try {
          const res = await this.getSubjectsByCycles(
            newCycles.map((c) => c.id)
          );

          Object.keys(res).forEach((cycleId) => {
            this.$set(this.subjectsByCycles, cycleId, res[cycleId]);
          });

          this.fillCycles();
        } catch (_) {
          this.$swal.fire({
            title: "Erro",
            text: "Não foi possível carregar as áreas do conhecimento. Tente novamente mais tarde.",
            icon: "error",
            showConfirmButton: false,
            timer: 3000,
          });
        } finally {
          this.loadingCycles = false;
        }
      } else {
        this.fillCycles();
      }
    },

    buildCyclesWithSubjects() {
      this.cyclesFilleds = this.cyclesSelected.map((cycle) => {
        const cycleData = this.subjectsByCycles[cycle.id];
        if (cycleData) {
          return {
            id: cycleData.cycle_id,
            name: cycleData.cycle_name,
            designation: cycleData.cycle_name,
            Subjects: (cycleData.Subjects || []).map((s) => ({
              id: s.subject_id,
              designation: s.subject_designation,
            })),
          };
        }
        return {};
      });
    },

    cleanInvalidSubjectsSelection() {
      const validSubjectIds = this.cyclesFilleds.flatMap((cycle) =>
        (cycle.Subjects || []).map((s) => s.id)
      );

      if (validSubjectIds.length > 0) {
        this.subjectsSelected = this.subjectsSelected.filter((subjectId) =>
          validSubjectIds.includes(subjectId)
        );
      }
    },

    fillCycles() {
      this.buildCyclesWithSubjects();
      this.cleanInvalidSubjectsSelection();
    },

    submit() {
      if (
        this.teacher.User.name == "" ||
        this.teacher.User.email == "" ||
        this.teacher.User.password == "" ||
        this.teacher.User.cpf == ""
      ) {
        this.$swal.fire({
          title: "Alerta",
          text: "Preencha todos os campos!",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        if (this.$route.params.id) {
          this.update();
        } else {
          this.create();
        }
      }
    },

    setNewPhoto(photo) {
      this.photo = photo;
    },

    selectCountry(country) {
      this.country = country;
    },

    selectState(state) {
      this.state = state;
    },

    successReq() {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: "Professor cadastrado com sucesso!",
      });

      let self = this;
      setTimeout(function () {
        self.redirectTo();
      }, 200);
    },

    redirectTo() {
      this.$router.push({
        name: "professores",
        params: {
          cycle: this.$route.params.cycle,
          subject: this.$route.params.subject,
          page: this.$route.params.page,
        },
      });
    },

    errorReq(error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.details &&
        error.response.data.details.length > 0
      ) {
        let errorHtml = "";
        error.response.data.details.forEach((err) => {
          errorHtml += `${err}<br>`;
        });

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          html: errorHtml,
          footer: "Por favor, verifique se todos os campos estão preenchidos.",
        });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Ocorreu um erro ao cadastrar o professor.",
        });
      }
    },
  },

  created() {
    if (this.id) this.setTeacher();
    this.getCyclesForSelect();
    this.getCountries();
    this.getStates();
  },

  destroyed() {
    this.resetStates();
    this.subjectsByCycles = {};
  },
};
</script>

<style lang="scss">
.teacher-profile {
  .form-group {
    &.required {
      &:after {
        right: 0;
      }
    }
  }
}

.container-rda .multiselect__tag-icon:after {
  color: white;
}

input.isInvalid {
  border-color: red;
}
</style>
